<template>
  <b-container fluid>
    <b-row>
      <b-col xl="12" lg="12" sm="12">
        <iq-card>
          <template v-slot:body>
            <b-row>
              <b-col v-if="notFound" xl="12" lg="12" sm="12" class="text-danger mb-2">
                  <div class="bg-gray pt-2 pb-2 pl-3">
                      <span>{{ (currentLocale === 'bn') ? "তথ্য পাওয়া যায়নি..!" : "Data not found..!" }}</span>
                  </div>
              </b-col>
              <b-col xl="12" lg="12" sm="12">
                <ValidationObserver ref="form"  v-slot="{ handleSubmit, reset }">
                  <b-form  @submit.prevent="handleSubmit(saveData)" @reset.prevent="reset" enctype="multipart/form-data">
                    <b-overlay :show="unitLoad">
                        <b-row>
                          <b-col lg="12" sm="12" class="mb-3">
                              <template>
                              <div style="font-size:18px; background-color: #005B5B;">
                                  <h5 class="text-white text-center">
                                      {{ $t('child_admission_management.student_basic_info') }}
                                  </h5>
                              </div>
                            </template>
                          </b-col>
                          <b-col xl="6" lg="6" sm="12">
                            <ValidationProvider name="Registration ID" vid="registration_id" rules="required|integer">
                              <b-form-group
                                  class="row"
                                  label-cols-sm="5"
                                  label-for="registration_id"
                                  slot-scope="{ valid, errors }"
                              >
                                <template v-slot:label>
                                  {{$t('child_admission_management.registration_id')}} <span class="text-danger">*</span>
                                </template>
                                <b-form-input class="form-control"
                                :disabled="id ? true : false"
                                v-model="assign.registration_id"
                                id="registration_id"
                                :state="errors[0] ? false : (valid ? true : null)"
                                ></b-form-input>
                                <div class="invalid-feedback">
                                    {{ errors[0] }}
                                </div>
                              </b-form-group>
                            </ValidationProvider>
                          </b-col>
                          <b-col xl="6" lg="6" sm="12">
                            <ValidationProvider name="Student Type" vid="student_type">
                                <b-form-group
                                  class="row"
                                  label-cols-sm="5"
                                  label-for="student_type"
                                  slot-scope="{ valid, errors }"
                              >
                                <template v-slot:label>
                                  {{$t('child_admission_management.student_type')}}
                                </template>
                                <b-form-input class="form-control"
                                v-model="assign.student_type"
                                id="student_type"
                                :state="errors[0] ? false : (valid ? true : null)"
                                disabled
                                ></b-form-input>
                                <div class="invalid-feedback">
                                    {{ errors[0] }}
                                </div>
                              </b-form-group>
                            </ValidationProvider>
                          </b-col>
                        </b-row>
                        <!-- Applicant's Name & Address -->
                        <b-row>
                          <b-col xl="6" lg="6" sm="12">
                            <ValidationProvider name="Student Name" vid="name" rules="">
                              <b-form-group
                                  class="row"
                                  label-cols-sm="5"
                                  label-for="name"
                                  slot-scope="{ valid, errors }"
                              >
                                <template v-slot:label>
                                  {{$t('globalTrans.name')}}
                                </template>
                                <b-form-input class="form-control"
                                v-model="assign.name"
                                id="name"
                                :state="errors[0] ? false : (valid ? true : null)"
                                disabled
                                ></b-form-input>
                                <div class="invalid-feedback">
                                    {{ errors[0] }}
                                </div>
                              </b-form-group>
                            </ValidationProvider>
                          </b-col>
                          <b-col xl="6" lg="6" sm="12">
                            <ValidationProvider name="Address" vid="address">
                              <b-form-group
                                  class="row"
                                  label-cols-sm="5"
                                  label-for="address"
                                  slot-scope="{ valid, errors }"
                              >
                                <template v-slot:label>
                                  {{$t('child_admission_management.address')}}
                                </template>
                                <b-form-input class="form-control"
                                v-model="assign.address"
                                id="address"
                                :state="errors[0] ? false : (valid ? true : null)"
                                disabled
                                ></b-form-input>
                                <div class="invalid-feedback">
                                    {{ errors[0] }}
                                </div>
                              </b-form-group>
                            </ValidationProvider>
                          </b-col>
                          <b-col xl="6" lg="6" sm="12">
                            <ValidationProvider name="Mobile No" vid="contact_no" rules="">
                              <b-form-group
                                  class="row"
                                  label-cols-sm="5"
                                  label-for="contact_no"
                                  slot-scope="{ valid, errors }"
                              >
                                <template v-slot:label>
                                  {{$t('child_admission_management.mobile_no')}}
                                </template>
                                <b-form-input class="form-control"
                                v-model="assign.contact_no"
                                id="contact_no"
                                :state="errors[0] ? false : (valid ? true : null)"
                                disabled
                                ></b-form-input>
                                <div class="invalid-feedback">
                                    {{ errors[0] }}
                                </div>
                              </b-form-group>
                            </ValidationProvider>
                          </b-col>
                        </b-row>
                        <!-- Organization Name & Institute Type -->
                        <b-row>
                          <b-col lg="12" sm="12" class="mb-3 mt-2">
                                <template>
                                <div style="font-size:18px; background-color: #005B5B;">
                                    <h5 class="text-white text-center">
                                        {{ $t('child_admission_management.present_school_info') }}
                                    </h5>
                                </div>
                              </template>
                          </b-col>
                          <b-col xl="6" lg="6" sm="12">
                            <ValidationProvider name="Organization Name" vid="org_name">
                                <b-form-group
                                  class="row"
                                  label-cols-sm="5"
                                  label-for="org_name"
                                  slot-scope="{ valid, errors }"
                                >
                                <template v-slot:label>
                                  {{$t('globalTrans.organization')}}
                                </template>
                                <b-form-input readonly
                                  plain
                                  v-model="assign.org_name"
                                  id="org_name"
                                  :state="errors[0] ? false : (valid ? true : null)"
                                >
                                <template v-slot:first>
                                  <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                </template>
                                </b-form-input>
                                <div class="invalid-feedback">
                                  {{ errors[0] }}
                                </div>
                                </b-form-group>
                            </ValidationProvider>
                          </b-col>
                          <b-col xl="6" lg="6" sm="12">
                            <ValidationProvider name="Institute Type" vid="institute_type">
                                <b-form-group
                                  class="row"
                                  label-cols-sm="5"
                                  label-for="institute_type"
                                  slot-scope="{ valid, errors }"
                                >
                                <template v-slot:label>
                                  {{$t('child_admission_management.institute_type')}}
                                </template>
                                <b-form-input readonly
                                  plain
                                  v-model="assign.institute_type"
                                  id="institute_type"
                                  :state="errors[0] ? false : (valid ? true : null)"
                                >
                                <template v-slot:first>
                                  <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                </template>
                                </b-form-input>
                                <div class="invalid-feedback">
                                  {{ errors[0] }}
                                </div>
                                </b-form-group>
                            </ValidationProvider>
                          </b-col>
                        </b-row>
                        <!-- Institute Name & Class -->
                        <b-row>
                          <b-col xl="6" lg="6" sm="12">
                            <ValidationProvider name="Institute Name" vid="institute_name">
                                <b-form-group
                                  class="row"
                                  label-cols-sm="5"
                                  label-for="institute_name"
                                  slot-scope="{ valid, errors }"
                                >
                                <template v-slot:label>
                                  {{$t('child_admission_management.institute_name')}}
                                </template>
                                <b-form-input readonly
                                  plain
                                  v-model="assign.institute_name"
                                  id="institute_name"
                                  :state="errors[0] ? false : (valid ? true : null)"
                                >
                                <template v-slot:first>
                                  <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                </template>
                                </b-form-input>
                                <div class="invalid-feedback">
                                  {{ errors[0] }}
                                </div>
                                </b-form-group>
                              </ValidationProvider>
                          </b-col>
                          <b-col xl="6" lg="6" sm="12">
                            <ValidationProvider name="School Name" vid="school_name" rules="">
                              <b-form-group
                                class="row"
                                label-cols-sm="5"
                                label-for="school_name"
                                slot-scope="{ valid, errors }"
                              >
                              <template v-slot:label>
                                {{$t('child_admission_management.c_school_name')}}
                              </template>
                              <b-form-input readonly
                                plain
                                v-model="assign.school_name"
                                id="school_name"
                                :state="errors[0] ? false : (valid ? true : null)"
                              >
                              <template v-slot:first>
                                <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                              </template>
                              </b-form-input>
                              <div class="invalid-feedback">
                                {{ errors[0] }}
                              </div>
                              </b-form-group>
                            </ValidationProvider>
                          </b-col>
                          <b-col lg="6" sm="12">
                              <ValidationProvider name="Class Name" vid="old_class_id" rules="required|min_value:1">
                                <b-form-group
                                    class="row"
                                    label-cols-sm="5"
                                    label-for="old_class_id"
                                    slot-scope="{ valid, errors }"
                                    >
                                    <template v-slot:label>
                                    {{$t('child_configuration.class')}} <span class="text-danger">*</span>
                                    </template>
                                    <b-form-select
                                        plain
                                    v-model="assign.old_class_id"
                                    id="old_class_id"
                                    :options="classList"
                                    :state="errors[0] ? false : (valid ? true : null)"
                                    >
                                    <template v-slot:first>
                                    <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                    </template>
                                    </b-form-select>
                                    <div class="invalid-feedback">
                                    {{ 'Class field required' }}
                                    </div>
                                  </b-form-group>
                          </ValidationProvider>
                          </b-col>
                        </b-row>
                        <b-row>
                          <b-col lg="12" sm="12" class="mb-3 mt-2">
                                <template>
                                <div style="font-size:18px; background-color: #005B5B;">
                                    <h5 class="text-white text-center">
                                        {{ $t('child_admission_management.school_transfer_info') }}
                                    </h5>
                                </div>
                              </template>
                          </b-col>
                          <b-col xl="6" lg="6" sm="12">
                            <ValidationProvider name="Organization Name" vid="org_id" rules="required|min_value:1">
                              <b-form-group
                                  class="row"
                                  label-cols-sm="5"
                                  label-for="org_id "
                                  slot-scope="{ valid, errors }"
                                    >
                                  <template v-slot:label>
                                    {{$t('institute_manangement.organization_name')}} <span class="text-danger">*</span>
                                  </template>
                                  <b-form-select
                                        plain
                                    v-model="assign.org_id"
                                    id="org_id"
                                    :options="orgList"
                                    :state="errors[0] ? false : (valid ? true : null)"
                                    >
                                    <template v-slot:first>
                                    <b-form-select-option :value="0" disabled>{{$t('globalTrans.select')}}</b-form-select-option>
                                    </template>
                                    </b-form-select>
                                    <div class="invalid-feedback">
                                    {{ errors[0] }}
                                    </div>
                                    </b-form-group>
                            </ValidationProvider>
                          </b-col>
                          <b-col xl="6" lg="6" sm="12">
                            <ValidationProvider name="Institute Type" vid="office_type_id" rules="required|min_value:1">
                              <b-form-group
                                        class="row"
                                        label-cols-sm="5"
                                        label-for="office_type_id"
                                        slot-scope="{ valid, errors }"
                                        >
                                        <template v-slot:label>
                                            {{$t('child_configuration.institute_type')}} <span class="text-danger">*</span>
                                        </template>
                                        <b-form-select
                                        plain
                                        v-model="assign.office_type_id"
                                        :options="officeTypeList"
                                        id="office_type_id"
                                        :state="errors[0] ? false : (valid ? true : null)"
                                        >
                                        <template v-slot:first>
                                            <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                        </template>
                                        </b-form-select>
                                        <div class="invalid-feedback">
                                        {{ errors[0] }}
                                        </div>
                              </b-form-group>
                            </ValidationProvider>
                          </b-col>
                        </b-row>
                        <!-- Institute Name & Class -->
                        <b-row>
                        <b-col lg="6" sm="12">
                                <ValidationProvider name="Institute Name" vid="office_id" rules="required|min_value:1">
                                    <b-form-group
                                        class="row"
                                        label-cols-sm="5"
                                        label-for="office_id"
                                        slot-scope="{ valid, errors }"
                                        >
                                        <template v-slot:label>
                                            {{$t('child_configuration.institute_name')}} <span class="text-danger">*</span>
                                        </template>
                                        <b-form-select
                                        plain
                                        v-model="assign.office_id"
                                        :options="officeList"
                                        id="office_id"
                                        :state="errors[0] ? false : (valid ? true : null)"
                                        >
                                        <template v-slot:first>
                                            <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                        </template>
                                        </b-form-select>
                                        <div class="invalid-feedback">
                                        {{ errors[0] }}
                                        </div>
                                    </b-form-group>
                                </ValidationProvider>
                            </b-col>
                            <b-col lg="6" sm="12">
                              <ValidationProvider name="Class Name" vid="class_id" rules="required|min_value:1">
                                <b-form-group
                                    class="row"
                                    label-cols-sm="5"
                                    label-for="class_id"
                                    slot-scope="{ valid, errors }"
                                    >
                                    <template v-slot:label>
                                    {{$t('child_configuration.class')}} <span class="text-danger">*</span>
                                    </template>
                                    <b-form-select
                                        plain
                                    v-model="assign.class_id"
                                    id="class_id"
                                    :options="classList"
                                    :state="errors[0] ? false : (valid ? true : null)"
                                    >
                                    <template v-slot:first>
                                    <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                    </template>
                                    </b-form-select>
                                    <div class="invalid-feedback">
                                    {{ 'Class field required' }}
                                    </div>
                                  </b-form-group>
                          </ValidationProvider>
                          </b-col>
                            <b-col xl="6" lg="6" sm="12">
                            <ValidationProvider name="School Name" vid="school_id" rules="">
                              <b-form-group
                                class="row"
                                label-cols-sm="5"
                                label-for="school_id"
                                slot-scope="{ valid, errors }"
                              >
                              <template v-slot:label>
                                {{$t('child_admission_management.school_name')}} <span class="text-danger">*</span>
                              </template>
                              <b-form-select
                                plain
                                v-model="assign.school_id"
                                id="school_id"
                              :options="schoolList"
                                :state="errors[0] ? false : (valid ? true : null)"
                              >
                              <template v-slot:first>
                                <b-form-select-option :value="0">{{$t('child_admission_management.others')}}</b-form-select-option>
                              </template>
                              </b-form-select>
                              <div class="invalid-feedback">
                                {{ errors[0] }}
                              </div>
                              </b-form-group>
                            </ValidationProvider>
                          </b-col>
                          <b-col xl="6" lg="6" sm="12">
                            <ValidationProvider name="DoB" vid="transfer_date">
                              <b-form-group
                                class="row"
                                label-cols-sm="5"
                                label-for="transfer_date"
                                slot-scope="{ valid, errors }"
                                  >
                                  <template v-slot:label>
                                  {{$t('child_admission_management.transfer_date')}} <span class="text-danger">*</span>
                                  </template>
                                <b-form-input
                                  class="date-picker"
                                  v-model="assign.transfer_date"
                                  placeholder="Select Date"
                                    id="transfer_date"
                                    :state="errors[0] ? false : (valid ? true : null)"
                                    ></b-form-input>
                                  <div class="invalid-feedback">
                                  {{ errors[0] }}
                                  </div>
                              </b-form-group>
                            </ValidationProvider>
                          </b-col>
                        </b-row>
                        <b-row v-if="external">
                                <b-col xl="6" lg="6" sm="12">
                                    <ValidationProvider name="External School (EN)" vid="external_school" rules="required">
                                      <b-form-group
                                          class="row"
                                          label-cols-sm="5"
                                          label-for="external_school"
                                          slot-scope="{ valid, errors }"
                                      >
                                        <template v-slot:label>
                                          {{$t('child_admission_management.external_school_en')}} <span class="text-danger">*</span>
                                        </template>
                                        <b-form-input class="form-control"
                                        v-model="assign.external_school"
                                        id="external_school"
                                        :state="errors[0] ? false : (valid ? true : null)"
                                        ></b-form-input>
                                        <div class="invalid-feedback">
                                            {{ errors[0] }}
                                        </div>
                                      </b-form-group>
                                    </ValidationProvider>
                              </b-col>
                              <b-col xl="6" lg="6" sm="12">
                                <ValidationProvider name="External School (BN)" vid="external_school_bn" rules="required">
                              <b-form-group
                                  class="row"
                                  label-cols-sm="5"
                                  label-for="external_school_bn"
                                  slot-scope="{ valid, errors }"
                              >
                                <template v-slot:label>
                                  {{$t('child_admission_management.external_school_bn')}} <span class="text-danger">*</span>
                                </template>
                                <b-form-input class="form-control"
                                v-model="assign.external_school_bn"
                                id="external_school_bn"
                                :state="errors[0] ? false : (valid ? true : null)"
                                ></b-form-input>
                                <div class="invalid-feedback">
                                    {{ errors[0] }}
                                </div>
                              </b-form-group>
                            </ValidationProvider>
                            </b-col>
                        </b-row>
                      <!-- Remarks (EN) -->
                        <b-row>
                          <b-col xl="6" lg="6" sm="12">
                              <ValidationProvider name="Remarks (EN)" vid="remarks">
                                <b-form-group
                                    class="row"
                                    label-cols-sm="5"
                                    label-for="remarks"
                                    slot-scope="{ valid, errors }"
                                >
                                <template v-slot:label>
                                    {{$t('child_admission_management.remarks_en')}}
                                </template>
                                <b-form-textarea
                                    id="remarks"
                                    v-model="assign.remarks"
                                    :state="errors[0] ? false : (valid ? true : null)"
                                    rows="2"
                                    max-rows="6"
                                    ></b-form-textarea>
                                    <div class="invalid-feedback">
                                    {{ errors[0] }}
                                    </div>
                                </b-form-group>
                              </ValidationProvider>
                          </b-col>
                          <b-col xl="6" lg="6" sm="12">
                              <ValidationProvider name="Remarks (BN)" vid="remarks_bn">
                                <b-form-group
                                    class="row"
                                    label-cols-sm="5"
                                    label-for="remarks_bn"
                                    slot-scope="{ valid, errors }"
                                >
                                <template v-slot:label>
                                    {{$t('child_admission_management.remarks_bn')}}
                                </template>
                                <b-form-textarea
                                    id="remarks_bn"
                                    v-model="assign.remarks_bn"
                                    :state="errors[0] ? false : (valid ? true : null)"
                                    rows="2"
                                    max-rows="6"
                                    ></b-form-textarea>
                                    <div class="invalid-feedback">
                                    {{ errors[0] }}
                                    </div>
                                </b-form-group>
                              </ValidationProvider>
                          </b-col>
                        </b-row>
                        <!-- Save/Cancel -->
                        <div class="row">
                          <div class="col-sm-3"></div>
                          <div class="col text-right">
                            <b-button type="submit" variant="primary" class="mr-2">{{ saveBtnName }}</b-button>
                            &nbsp;
                            <b-button variant="danger" class="mr-1" @click="$bvModal.hide('modal-4')">{{ $t('globalTrans.cancel') }}</b-button>
                          </div>
                        </div>
                    </b-overlay>
                  </b-form>
                </ValidationObserver>
              </b-col>
            </b-row>
          </template>
        </iq-card>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import RestApi, { childServiceBaseUrl } from '@/config/api_config'
import { schoolTrnsferStoreApi, getResidentDetail2, schoolTrnsferUpdateApi } from '../../api/routes'
import flatpickr from 'flatpickr'
import { isNotEmpty } from '@amcharts/amcharts4/.internal/core/utils/Utils'

export default {
  props: ['id'],
  components: {
    ValidationObserver,
    ValidationProvider
  },
  data () {
    return {
      saveBtnName: this.id ? this.$t('globalTrans.update') : this.$t('globalTrans.save'),
      assign: {
        student_type: '',
        org_name: '',
        institute_type: '',
        institute_name: '',
        registration_id: '',
        address: '',
        address_bn: '',
        org_id: 0,
        office_type_id: 0,
        office_id: 0,
        old_class_id: 0,
        class_id: 0,
        school_name: '',
        school_id: 0,
        old_school_id: 0,
        transfer_date: '',
        old_external_school: '',
        old_external_school_bn: '',
        external_school: '',
        external_school_bn: '',
        remarks: '',
        remarks_bn: ''
      },
      schoolList: [],
      external: true,
      officeTypeList: [],
      officeList: [],
      notFound: false,
      unitLoad: false
    }
  },
  computed: {
    orgList: function () {
      return this.$store.state.commonObj.organizationProfileList.filter(item => item.status === 0)
    },
    classList: function () {
      return this.$store.state.ChildService.commonObj.classList.filter(item => item.status === 1)
    },
    currentLocale () {
      return this.$i18n.locale
    }
  },
  created () {
    if (this.id) {
      const tmp = this.getAssignData()
      // Object.freeze(tmp)
      this.assign = tmp
      this.assign.org_name = this.getOrgName(tmp.old_org_id)
      this.assign.student_type = this.getStudentType(tmp.student_type)
      this.assign.institute_type = this.getInstituteType(tmp.old_office_type_id)
      this.assign.institute_name = this.getInstituteName(tmp.old_office_id)
      if (tmp.old_school_id === 0) {
        this.assign.school_name = this.$i18n.locale === 'bn' ? tmp.old_external_school_bn : tmp.old_external_school
      } else {
        this.assign.school_name = this.getSchoolId(tmp.old_school_id)
      }
    }
      this.assign.org_id = this.$store.state.dataFilters.orgId
      this.assign.office_type_id = this.$store.state.dataFilters.officeTypeId
      this.assign.office_id = this.$store.state.dataFilters.officeId
  },
  mounted () {
    flatpickr('.date-picker', {})
    },
  watch: {
    'assign.registration_id': function (newVal, oldVal) {
      if (!this.id) {
        this.notFound = false
        this.assign.name = ''
        this.assign.org_name = ''
        this.assign.student_type = ''
        this.assign.institute_type = ''
        this.assign.institute_name = ''
        this.assign.address = ''
        this.assign.contact_no = ''
        this.assign.school_name = ''
        if (oldVal !== newVal) {
            if (newVal.length === 11) {
                this.getResident(newVal)
            }
        }
      }
      },
      'assign.org_id': function (newVal) {
          this.officeTypeList = this.getofficeTypeList(newVal)
      },
      'assign.office_type_id': function (newVal) {
          this.officeList = this.getOfficeList(newVal)
      },
      'assign.office_id': function (newVal) {
          this.schoolList = this.getSchoolList(newVal)
      },
      'assign.school_id': function (newVal) {
          if (newVal === 0) {
            this.external = true
          } else {
            this.external = false
          }
      }
  },
  methods: {
      getClassName (id) {
            const className = this.$store.state.ChildService.commonObj.classList.find(item => item.value === id)
            if (this.$i18n.locale === 'bn') {
                return className.text_bn
            } else {
                return className.text_en
            }
      },
      getResident ($regId) {
          this.unitLoad = true
          RestApi.getData(childServiceBaseUrl, getResidentDetail2 + '/' + $regId).then(response => {
              if (isNotEmpty(response.data)) {
                  this.unitLoad = false
                  this.assign.name = this.$i18n.locale === 'bn' ? response.data.name_bn : response.data.name
                  this.assign.student_type = this.getStudentType(response.data.student_type)
                  this.assign.old_org_id = response.data.org_id
                  this.assign.old_office_type_id = response.data.office_type_id
                  this.assign.old_office_id = response.data.office_id
                  this.assign.org_name = this.getOrgName(response.data.org_id)
                  this.assign.institute_type = this.getInstituteType(response.data.office_type_id)
                  this.assign.institute_name = this.getInstituteName(response.data.office_id)
                  this.assign.address = this.$i18n.locale === 'bn' ? response.data.address_bn : response.data.address
                  this.assign.contact_no = response.data.contact_no
                  this.assign.old_class_id = response.data.class_id
                  if (response.data.school_id === 0) {
                    this.assign.school_name = this.$i18n.locale === 'bn' ? response.data.external_school_bn : response.data.external_school
                    this.assign.old_external_school = response.data.external_school
                    this.assign.old_external_school_bn = response.data.external_school_bn
                  } else {
                    this.assign.school_name = this.getSchoolId(response.data.school_id)
                    this.assign.old_school_id = response.data.school_id
                  }
                  this.notFound = false
              } else {
                this.unitLoad = false
                this.notFound = true
              }
          })
      },
      getSchoolList (officeId) {
          return this.$store.state.ChildService.commonObj.schoolList.filter(item => item.status === 1 && item.office_id === officeId)
      },
       getAssignData () {
          const tmpData = this.$store.state.list.find(item => item.id === this.id)
          return JSON.parse(JSON.stringify(tmpData))
       },
        getOrgName (orgId) {
                const tmpData = this.$store.state.commonObj.organizationProfileList.find(item => item.value === orgId && item.status === 0)
                if (this.$i18n.locale === 'bn') {
                    return tmpData.text_bn
                } else {
                    return tmpData.text_en
                }
        },
        getStudentType (typeId) {
        const Type = this.$store.state.ChildService.commonObj.studentTypeList.find(type => type.value === typeId)
        if (this.$i18n.locale === 'bn') {
            return Type.text_bn
        } else {
            return Type.text_en
        }
        },
        getSchoolId (schlId) {
        const Type = this.$store.state.ChildService.commonObj.schoolList.find(item => item.value === schlId)
        if (this.$i18n.locale === 'bn') {
            return Type.text_bn
        } else {
            return Type.text_en
        }
        },
        getInstituteType (Id) {
            const tmpData = this.$store.state.commonObj.officeTypeList.find(item => item.value === Id && item.status === 0)
            if (this.$i18n.locale === 'bn') {
                return tmpData.text_bn
            } else {
                return tmpData.text_en
            }
        },
        getInstituteName (Id) {
            const tmpData = this.$store.state.commonObj.officeList.find(item => item.value === Id && item.status === 0)
            if (this.$i18n.locale === 'bn') {
                return tmpData.text_bn
            } else {
                return tmpData.text_en
            }
        },
      async saveData () {
          this.unitLoad = true
          this.$store.dispatch('mutateCommonProperties', { loading: true })
          let result = null
          const loadingState = { loading: false, listReload: false }
          if (this.id) {
            result = await RestApi.putData(childServiceBaseUrl, `${schoolTrnsferUpdateApi}/${this.id}`, this.assign)
          } else {
          result = await RestApi.postData(childServiceBaseUrl, schoolTrnsferStoreApi, this.assign)
          }
          loadingState.listReload = true

          this.$store.dispatch('mutateCommonProperties', loadingState)

          if (result.success) {
            this.$toast.success({
              title: this.$t('globalTrans.success'),
              message: this.id ? this.$t('globalTrans.update_msg') : this.$t('globalTrans.save_msg'),
              color: '#D6E09B'
            })
            this.unitLoad = false
            this.$bvModal.hide('modal-4')
          } else {
            this.unitLoad = false
            this.$toast.error({
              title: this.$t('globalTrans.error'),
              message: this.$i18n.locale === 'bn' ? 'ইতিমধ্যে একটি ট্রান্সফার প্রক্রিয়াধীন আছে!' : 'Already have a pending transfer..!',
              color: '#D6E09B'
            })
            this.$refs.form.setErrors(result.errors)
          }
      },
       getofficeTypeList (orgId = null) {
            const instituteTypeList = this.$store.state.commonObj.officeTypeList.filter(item => item.status === 0 && [15, 53, 28, 16, 18, 22, 17, 25, 24, 43, 52, 51, 44, 23, 31, 54, 49, 13, 55, 47, 46, 50, 48, 19, 21, 3].includes(item.value))
            if (orgId) {
                return instituteTypeList.filter(institute => institute.org_id === orgId)
            }
            return instituteTypeList
        },
        getOfficeList (typeId = null) {
            const instituteList = this.$store.state.commonObj.officeList.filter(item => item.status === 0)
            if (typeId) {
                return instituteList.filter(institute => institute.office_type_id === typeId)
            }
            return instituteList
        }
  }
}
</script>
